import "@/App.css";
import { BrowserRouter, Routes, Route, Link, Navigate } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import Home from "./pages/Home";
import BestVpns from "./pages/BestVpns";
import ReviewPage from "./pages/ReviewPage";
import ComparePage from "./pages/ComparePage";
import BestForPage from "./pages/BestForPage";
import RankingPage from "./pages/RankingPage";
import LearnPage from "./pages/LearnPage";
import News from "./pages/News";
import DealsPage from "./pages/DealsPage";
import { BlogIndex, BlogPost } from "./pages/Blog";
import { ReviewsIndex, CompareIndex, BestForIndex, RankingsIndex, LearnIndex } from "./pages/HubPages";
import { About, Contact, PrivacyPolicy, AffiliateDisclosure } from "./pages/StaticPages";
import { Terms, Disclaimer, EditorialPolicy, CommercialRelationships } from "./pages/LegalPages";
import { AuthProvider } from "./context/AuthContext";
import AdminLogin from "./pages/admin/AdminLogin";
import AdminDashboard from "./pages/admin/AdminDashboard";
import AdminEditor from "./pages/admin/AdminEditor";
import { Toaster } from "./components/ui/sonner";
import { Layout } from "./components/Layout";
import { Helmet } from "react-helmet-async";

const NotFound = () => (
  <Layout>
    <Helmet>
      <title>Page Not Found | VPNReviews.ai</title>
      <meta name="robots" content="noindex, nofollow" />
    </Helmet>
    <div className="mx-auto flex max-w-3xl flex-col items-start px-6 py-32 lg:px-8">
      <p className="text-xs font-bold uppercase tracking-[0.25em] text-[#4687FF]">404</p>
      <h1 className="mt-4 font-display text-4xl font-black tracking-tighter text-[#0F172A] sm:text-5xl">
        This page slipped through the tunnel.
      </h1>
      <Link to="/" data-testid="notfound-home-link" className="mt-8 bg-[#4687FF] px-7 py-3.5 font-display text-sm font-bold text-white hover:bg-[#2563eb]">
        Back to the rankings
      </Link>
    </div>
  </Layout>
);

function App() {
  return (
    <HelmetProvider>
      <AuthProvider>
        <BrowserRouter>
          <Toaster position="top-right" richColors />
          <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/best-vpns" element={<BestVpns />} />
          <Route path="/reviews" element={<ReviewsIndex />} />
          <Route path="/reviews/:slug" element={<ReviewPage />} />
          <Route path="/compare" element={<CompareIndex />} />
          <Route path="/compare/:slug" element={<ComparePage />} />
          <Route path="/best-vpn-for" element={<BestForIndex />} />
          <Route path="/best-vpn-for/:slug" element={<BestForPage />} />
          <Route path="/rankings" element={<RankingsIndex />} />
          <Route path="/rankings/:slug" element={<RankingPage />} />
          <Route path="/learn" element={<LearnIndex />} />
          <Route path="/learn/:slug" element={<LearnPage />} />
          <Route path="/blog" element={<BlogIndex />} />
          <Route path="/blog/:slug" element={<BlogPost />} />
          <Route path="/news" element={<News />} />
          <Route path="/deals" element={<DealsPage />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/affiliate-disclosure" element={<AffiliateDisclosure />} />
          <Route path="/terms-and-conditions" element={<Terms />} />
          <Route path="/disclaimer" element={<Disclaimer />} />
          <Route path="/editorial-policy" element={<EditorialPolicy />} />
          <Route path="/commercial-relationships" element={<CommercialRelationships />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<AdminDashboard />} />
          <Route path="/admin/posts/new" element={<AdminEditor type="posts" />} />
          <Route path="/admin/posts/:id" element={<AdminEditor type="posts" />} />
          <Route path="/admin/news/new" element={<AdminEditor type="news" />} />
          <Route path="/admin/news/:id" element={<AdminEditor type="news" />} />
          <Route path="/home" element={<Navigate to="/" replace />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
        </BrowserRouter>
      </AuthProvider>
    </HelmetProvider>
  );
}

export default App;
